// @spec GHG-STR-015
// @spec GHG-STR-084
'use client';

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { TravelImportWizard } from '@/features/ghg/components/TravelImportWizard';
import { useGHGPagePeriod } from '@/features/ghg/hooks/use-ghg-page-period';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ghg/travel-import')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.importTravelData'),
  }),
  component: TravelImportPage,
});

/** Travel Data Import page for bulk importing business travel data. */
function TravelImportPage() {
  const { periodId } = useGHGPagePeriod();
  const navigate = useNavigate();

  const handleDone = () => {
    void navigate({ to: '/ghg/business-travel' });
  };

  return (
    <div className="p-8">
      <div className="max-w-4xl mx-auto space-y-8">
        <header>
          <h1 className="text-3xl font-semibold text-foreground">Import Travel Data</h1>
          <p className="mt-1 text-muted-foreground">
            Upload and import business travel records for Scope 3 Category 6 emissions
          </p>
        </header>

        <TravelImportWizard key={periodId} onComplete={handleDone} onCancel={handleDone} />
      </div>
    </div>
  );
}
